import { all } from "redux-saga/effects";
import { pricesSagas } from "./Prices/Prices.sagas";
import { globalStatsSagas } from "./GlobalStats/GlobalStats.sagas";
import { foundationAddressesSagas } from "./FoundationAddresses/FoundationAddresses.sagas";
import { tokenTransfersSagas } from "./TokenTransfers/TokenTransfers.sagas";
import { tokenTransactionsSagas } from "./TokenTransactions/TokenTransactions.sagas";
import { accountTransactionsSagas } from "./AccountTransactions/AccountTransactions.sagas";
import { accountInfoSagas } from "./AccountInfo/AccountInfo.sagas";
import { tokenHoldersSagas } from "./TokenHolders/TokenHolders.sagas";
import { burnSagas } from "./Burn/Burn.sagas";
import { transactionInfoSagas } from "./TransactionInfo/TransactionInfo.sagas";
import { contractInfoSagas } from "./ContractInfo/ContractInfo.sagas";
import { tokenInfoSagas } from "./TokenInfo/TokenInfo.sagas";
import { blocksSagas } from "./Blocks/Blocks.sagas";

function* rootSaga() {
  yield all([
    pricesSagas(),
    globalStatsSagas(),
    foundationAddressesSagas(),
    tokenTransfersSagas(),
    tokenTransactionsSagas(),
    accountTransactionsSagas(),
    accountInfoSagas(),
    tokenHoldersSagas(),
    burnSagas(),
    transactionInfoSagas(),
    contractInfoSagas(),
    tokenInfoSagas(),
    blocksSagas(),
  ]);
}

export default rootSaga;
